// @flow

import { i18n } from 'shared/utils';
import type { FilterOption } from 'main-app/components/FilterControls';

export default (): Array<FilterOption> => [
  {
    label: i18n.t('Customer'),
    name: 'customerIds',
    type: 'customer',
    multi: true,
  },
  {
    label: i18n.t('Status'),
    name: 'statuses',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Requested'), value: 'REQUESTED' },
      { label: i18n.t('Authorized'), value: 'AUTHORIZED' },
      { label: i18n.t('Received'), value: 'RECEIVED' },
      { label: i18n.t('Closed'), value: 'CLOSED' },
      { label: i18n.t('Rejected'), value: 'REJECTED' },
    ],
  },
  {
    label: i18n.t('Return Type'),
    name: 'returnTypes',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Refund'), value: 'REFUND' },
      { label: i18n.t('Replacement'), value: 'REPLACEMENT' },
      { label: i18n.t('Repair'), value: 'REPAIR' },
      { label: i18n.t('Credit'), value: 'CREDIT' },
    ],
  },
  {
    label: i18n.t('Reason'),
    name: 'reasons',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Defective'), value: 'DEFECTIVE' },
      { label: i18n.t('Wrong Item'), value: 'WRONG_ITEM' },
      { label: i18n.t('Damaged'), value: 'DAMAGED' },
      { label: i18n.t('Not as Described'), value: 'NOT_AS_DESCRIBED' },
      { label: i18n.t('Customer Changed Mind'), value: 'CUSTOMER_CHANGED_MIND' },
      { label: i18n.t('Other'), value: 'OTHER' },
    ],
  },
];
